import { isStaffUser } from "~/utils/permissions";

// Сотрудник: ADMIN или MANAGER — у обоих есть вход в админку
export const useStaff = () => {
  const authUser = useAuthUser();
  return computed(() => isStaffUser(authUser.value));
};
